import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import { MenuItem } from "@mui/material";

function FontWeight({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      options={[
        <MenuItem key={"default"} value={""}>
          Default
        </MenuItem>,
        ["lighter", "normal", "bold", "bolder"].map((fontWeight) => {
          return (
            <MenuItem key={fontWeight} value={fontWeight}>
              <span style={{ fontWeight }}>{fontWeight}</span>
            </MenuItem>
          );
        }),
      ]}
      rules={{ required }}
    />
  );
}

export const JSFontWeightComponent: JSInputComponent = {
  Component: FontWeight,
  handlesCssProperties: ["fontWeight"],
};
